<template>
  <transition name="country-selection-fade" @after-leave="handleAfterLeave">
    <div class="country-box" v-show="visible">
      <div class="container">
        <h1>选择国家</h1>
        <el-row :gutter="15" class="list">
          <el-col :span="6" v-for="country in countrys" :key="country.CountryId">
            <el-button round class="btn" :class="selectedCountryID === country.CountryId ? 'active' : ''" @click="countrySelectedAction(country.CountryId)">{{country.CountryChineseSimplifiedName}}</el-button>
          </el-col>
        </el-row>
        <div class="actions">
          <el-button type="primary" round class="action-btn" :disabled="selectedCountryID ? false: true" @click="submitAction">保存</el-button>
          <el-button type="text" class="action-btn cancel" @click="dismiss">取消</el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CountrySelection',
  data () {
    return {
      visible: false,
      closed: false,
      onClose: null,
      onSelected: null,
      countrys: [],
      selectedCountryID: null
    }
  },
  created () {
    this.getCountrys()
  },
  mounted () {
    document.body.style.overflow = 'hidden'
  },
  destroyed () {
    document.body.style.overflow = null
  },
  watch: {
    closed (newValue) {
      if (newValue) {
        this.visible = false
      }
    }
  },
  methods: {
    getCountrys () {
      this.$api.system.getCountrys().then(res => {
        this.countrys = res.data
      }).catch(err => {
        console.log(err)
      })
    },
    countrySelectedAction (id) {
      this.selectedCountryID = id
    },
    handleAfterLeave () {
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    },
    submitAction () {
      if (typeof this.onSelected === 'function') {
        let country = this.countrys.find(c => c.CountryId === this.selectedCountryID)
        this.onSelected(country)
      }
      this.dismiss()
    },
    dismiss () {
      this.closed = true
      if (typeof this.onClose === 'function') {
        this.onClose()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.country-selection-fade-enter,
.country-selection-fade-leave-active {
  opacity:0;
}

.country-box {
  transition: opacity .3s;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;

  .container {
    background-color: white;
    box-sizing: border-box;
    width: 570px;
    padding: 40px 30px 20px;
    border-radius: 8px;

    h1 {
      font-size: 14px;
      font-weight: bold;
      color: #22b196;
    }

    .list {
      margin-top: 25px;
    }
  }

  .btn {
    width: 100%;
    margin-bottom: 15px;

    &.active {
      color: rgb(31, 159, 135);
      border-color: rgb(31, 159, 135);
      background-color: initial;
      outline: 0;
    }
  }
}
.actions {
  text-align: right;

  .action-btn {
    width: 100px;
    margin-left: 10px;
  }
}
</style>
